import { render, staticRenderFns } from "./MenuContent.vue?vue&type=template&id=f5bb6dbc&scoped=true&"
import script from "./MenuContent.vue?vue&type=script&lang=ts&"
export * from "./MenuContent.vue?vue&type=script&lang=ts&"
import style0 from "./MenuContent.vue?vue&type=style&index=0&id=f5bb6dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bb6dbc",
  null
  
)

export default component.exports